import { useMemo } from 'react';
import type { Channel, ChannelMemberResponse } from 'stream-chat';

export const GROUP_CHANNEL_TYPES = ['commons', 'ecoregion', 'community', 'activity'] as const;

const getChannelName = (members: ChannelMemberResponse[]): string => {
  if (!members.length) return 'User';
  const names = members.slice(0, 3).map(member => member.user?.name || 'User');
  if (members.length > 3) {
    return `${names.join(', ')} + ${members.length - 3}`;
  }
  return names.join(', ');
};

export const useChannelDisplayName = (channel: Channel, members: ChannelMemberResponse[]) => {
  return useMemo(() => {
    const isGroupChannel = GROUP_CHANNEL_TYPES.includes(channel.type as any);
    if (isGroupChannel) {
      return channel.data?.name || `${channel.type || 'Chat'}`;
    }
    return channel.data?.name || getChannelName(members);
  }, [channel, members]);
};
